import Vue from 'vue';

import LoadErrorComponent from 'components/LoadError.vue';

const loadErrorContainer = document.createElement('div', { class: 'load-error' });
document.body.appendChild(loadErrorContainer);
new Vue(LoadErrorComponent).$mount(loadErrorContainer);
